<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Site not found
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-alert>
          Uuups, the requested site does not exist. Go back to the <v-btn to="/dashboard">Dashboard</v-btn>
        </v-alert>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import config from "@/utils/config.json";
  // import TitleHeader from "@/components/TitleHeader.vue";


  export default {
    name: "NotFoundComponent",
    components: {
      // TitleHeader
    },
    computed: {
      referralLink() {
        return "https://wisetoken.net/?w=" + config.referralAccount;
      },
    }
  };
</script>

<style></style>
